function ArrivingTomorrowIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#4299E1" />
      <path
        d="M22.9482 8.06254C23.3237 8.0687 23.625 8.3745 23.625 8.75004V21.2805C23.6248 21.5259 23.4938 21.7527 23.2812 21.8753L16.4062 25.8445C15.9481 26.1089 15.3755 25.7785 15.375 25.2497V21.968H11.25C10.8703 21.9679 10.5626 21.6602 10.5625 21.2805V19.2369C10.5563 18.8488 10.8726 18.5326 11.2607 18.5386C11.6404 18.5448 11.9434 18.8572 11.9375 19.2369V20.5931H15.375V12.7193C15.3747 12.4733 15.5058 12.246 15.7187 12.1231L20.3701 9.43759H11.9375V10.7857C11.9444 11.2506 11.597 11.4826 11.25 11.4826C10.9029 11.4826 10.5559 11.2506 10.5625 10.7857V8.75C10.5626 8.3703 10.8704 8.06257 11.25 8.0625L22.9482 8.06254ZM18.8124 16.3111C18.6301 16.3111 18.4553 16.3835 18.3263 16.5124C18.1974 16.6413 18.1249 16.8162 18.1249 16.9985C18.1249 17.1808 18.1974 17.3557 18.3263 17.4846C18.4553 17.6136 18.6301 17.686 18.8124 17.686C18.9948 17.686 19.1696 17.6136 19.2986 17.4846C19.4275 17.3557 19.4999 17.1808 19.4999 16.9985C19.4999 16.8162 19.4275 16.6414 19.2986 16.5124C19.1696 16.3835 18.9948 16.3111 18.8124 16.3111Z"
        fill="#fff"
      />
      <path
        d="M9.19398 11.9207C9.01057 11.919 8.83397 11.9906 8.70364 12.1197C8.57323 12.2488 8.4999 12.4247 8.49982 12.6082V14.3269H5.07186C4.68427 14.3214 4.36903 14.6378 4.37497 15.0212C4.38113 15.4045 4.69265 15.7072 5.07186 15.7019H8.49982V17.4207C8.4999 17.5891 8.5617 17.7515 8.67356 17.8774C8.78542 18.0033 8.93954 18.0837 9.10676 18.1035C9.27398 18.1232 9.44263 18.081 9.58071 17.9846L13.0193 15.5771C13.2031 15.4484 13.3125 15.2382 13.3125 15.0139C13.3125 14.7895 13.2031 14.5792 13.0193 14.4505L9.58071 12.0443C9.4672 11.9651 9.33242 11.922 9.19399 11.9207L9.19398 11.9207Z"
        fill="#fff"
      />
    </svg>
  )
}

export default ArrivingTomorrowIcon
